import { rootMargin } from '@helpers/animate';
import { useInView } from '@hooks/useInView';
import ReviewCard from '@stories/Components/Cards/ReviewCard/ReviewCard';
import * as React from 'react';
import S from './SingleTestimonial.styles';
const SingleTestimonial = (props) => {
    const [ref, inView] = useInView({ rootMargin }, false, props.pageContext?.isEditMode);
    return (React.createElement(S.Container, { id: props.anchorId, ref: ref, "data-animate": inView, spacing: "padding" },
        React.createElement(S.TitleWrapper, null,
            React.createElement(S.Title, null, props.title)),
        React.createElement(S.CardWrapper, null,
            React.createElement(ReviewCard, { index: 0, isSingle: true, ...props.review }))));
};
export default SingleTestimonial;
